import api from './api';

// Yıl sonu izin mutabakat formu — İK takip yüzeyi (spec §12.3, Görev 12) +
// çalışanın kendi formu (Görev 11 — koordinasyon boşluğu turu, MyLeavesPage.js).

// Boş/null parametreleri düşür — sorgu dizesi temiz kalsın (leaveBalanceReportService deseni).
const clean = (params) => {
  const out = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') out[key] = value;
  });
  return out;
};

// GÜVENLİK (backend review turu 1, I-1/I-2): tekil uçlar opak `{id}` DEĞİL,
// `(userId, year)` çiftiyle adreslenir — liste satırı zaten ikisini de taşır.
// `passErrorBody: true` (final inceleme, M-3): api.js başarısız bir GET'i
// varsayılan olarak EMPTY_RESPONSE'a indirger ve `message` alanı KAYBOLUR —
// çağıran modül-kapalı (403 leaveReconciliation.moduleNotActive), kapsamsız
// (403 leaveReconciliation.noScope), geçersiz yıl (400) ve 500'ü ayırt
// edemiyor, hepsini "Size bağlı personel bulunamadı." diye gösteriyordu.
// Bu bayrak GERÇEK gövdeyi geçirir.
//
// `skipErrorToast: true` (düzeltme turu 3b, Bulgu 5): M-3'ten sonra AYNI
// CÜMLE İKİ KEZ basılıyordu — bir kez Axios interceptor'ın kırmızı toast'ı
// (`i18n.t('responseErrors.' + message)`), bir kez de sayfanın boş tablosunun
// içindeki `ScopeHint` satırı (`t(scopeError)` — aynı anahtar). Bu depoda
// toast YALNIZ interceptor'da olur, yani çözüm satır içi açıklamayı kaldırmak
// DEĞİL, bu GET için toast'ı susturmaktır: sayfa hatayı zaten yerinde ve
// kalıcı olarak anlatıyor.
export const getLeaveReconciliations = (params) =>
  api.get('/v1/leave-reconciliations', {
    params: clean(params),
    passErrorBody: true,
    skipErrorToast: true,
  });

export const getLeaveReconciliationPdf = (userId, year) =>
  api.get(`/v1/leave-reconciliations/${userId}/${year}/pdf`, { responseType: 'blob' });

// Bulgu G (düzeltme turu 2): donmuş dökümü BİLEREK tazeleyen AÇIK eylem.
// İndirme (GET .../pdf) donmuş dökümü basar ve onu ASLA değiştirmez; bu uç
// POST'tur ve `LM.Write` ister. `delivered` bir kayıtta backend 400
// (`leaveReconciliation.alreadyDelivered`) döner — İK önce teslimi geri almalı.
export const regenerateLeaveReconciliation = (userId, year) =>
  api.post(`/v1/leave-reconciliations/${userId}/${year}/regenerate`, null, { responseType: 'blob' });

export const deliverLeaveReconciliation = (userId, year, data) =>
  api.post(`/v1/leave-reconciliations/${userId}/${year}/deliver`, data);

// Geri alma gerekçesi backend'de ZORUNLU (leaveReconciliation.noteRequired) — bu servis
// katmanı zorlamaz, form (config/index.js) `required: true` ile önden engeller.
export const revokeLeaveReconciliation = (userId, year, note) =>
  api.post(`/v1/leave-reconciliations/${userId}/${year}/revoke`, { note });

// ------------------------------------------------------------------
// /my — çalışanın kendi mutabakatı. Modül kapısı YOK (controller yorumu: LM
// aboneliğinden bağımsız erişilebilmeli), bu yüzden İK metotlarının aksine
// [ModuleAuthorize] gerektirmez.
// ------------------------------------------------------------------

// Kayıt hiç üretilmemişse backend 404 (`leaveReconciliation.notFound`) döner —
// bu GERÇEK bir hata değil, "henüz oluşturulmadı" durumudur (spec: ilk PDF
// indirmede kayıt kendiliğinden açılır). `skipErrorToast` bu TEK anahtar için
// toast'ı bastırır; başka bir hata (ör. ağ kopması) yine normal toast alır.
// api.js GET okumalarında REJECT ETMEZ — gerçek sinyal `res.data.status`,
// interceptor 404'te gövdeyi EMPTY_RESPONSE'a indirger (mesaj/errorCode
// KORUNMAZ) — çağıran "kayıt yok" ile "yüklenemedi"yi status alanından ayırt
// edemez, yalnız ikisini de "veri yok" sayar; bu davranış burada kasıtlıdır
// (aşağıdaki component `status:false`i her koşulda "henüz oluşturulmadı"
// olarak ele alır, buton yine aktif kalır).
export const getMyReconciliation = (year) =>
  api.get('/v1/leave-reconciliations/my', {
    params: { year },
    skipErrorToast: ['leaveReconciliation.notFound'],
  });

// Kayıt yoksa backend (`BuildMyPdfAsync` → `GetOrCreateAsync`) onu KENDİSİ
// açar — bu uç asla "kayıt yok" nedeniyle 404 dönmez, yalnız gerçek hatalarda.
export const downloadMyReconciliationPdf = (year) =>
  api.get('/v1/leave-reconciliations/my/pdf', { params: { year }, responseType: 'blob' });

// Bulgu G: çalışanın kendi formunu tazelemesi. `/my/pdf` modül kapısı taşımaz
// ve İÇİNDE BULUNULAN yılı kabul eder — Mart'ta forma basan çalışan o yılın
// belgesini Mart verisine çiviliyordu ve geri dönüş yolu YOKTU.
export const regenerateMyReconciliation = (year) =>
  api.post('/v1/leave-reconciliations/my/regenerate', null, { params: { year }, responseType: 'blob' });

// ------------------------------------------------------------------
// Toplu işler — formları tek ZIP'te indirme ve çalışanlara bağlantılı
// bildirim. Ağır iş sunucuda ARKA PLANDA koşar (LeaveReconciliationBulkJobWorker);
// bu uçlar yalnız kuyruğu yönetir. Gövde (önizleme = başlatma):
//   { kind: 'zip'|'notify', year, scope: 'selected'|'filter', employeeIds,
//     departmentId, status, regenerateGenerated, skipAlreadyNotified }
// ------------------------------------------------------------------

// Önizleme çekmece açıkken ve her seçenek değişiminde KENDİLİĞİNDEN çağrılır —
// hatası (ör. `bulkNoTargets`) çekmecenin içinde yazılır, toast'a düşmez.
export const previewLeaveReconciliationBulkJob = (request) =>
  api.post('/v1/leave-reconciliations/bulk-jobs/preview', request, { skipErrorToast: true });

// Başarı toast'ı sunucunun `leaveReconciliation.bulkJobQueued` mesajından
// interceptor'da çıkar; 409 (`bulkJobInProgress`) normal hata toast'ı alır.
export const createLeaveReconciliationBulkJob = (request) =>
  api.post('/v1/leave-reconciliations/bulk-jobs', request);

// İş sürerken yoklanır. `skipErrorToast`: yoklama başarısızlığı her turda
// toast basmasın — çağıran başarısızlıkta yoklamayı DURDURUR (bağlantı
// kopmasının toast'ı interceptor'da bu bayraktan bağımsız bir kez çıkar).
export const getLeaveReconciliationBulkJobs = () =>
  api.get('/v1/leave-reconciliations/bulk-jobs', { skipErrorToast: true });

// 15 dk geçerli imzalı adres döner; dosya `files.` alan adından iner ve
// indirme adı sunucuda (Content-Disposition) yazılıdır.
export const getLeaveReconciliationBulkJobDownload = (id) =>
  api.get(`/v1/leave-reconciliations/bulk-jobs/${id}/download`);

export const cancelLeaveReconciliationBulkJob = (id) =>
  api.post(`/v1/leave-reconciliations/bulk-jobs/${id}/cancel`);
